import { h } from "omi";

import { IconProps } from "../icons.ts";

export function StarIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 12 12">
      <path
        d="M5.6394 1.7267c.1152-.2335.1728-.3502.251-.3875a.25.25 0 0 1 .2153 0c.0782.0373.1358.154.251.3875l1.0934 2.215c.034.0689.051.1033.0759.13a.25.25 0 0 0 .0777.0566c.0331.0154.0712.021.1472.032l2.4456.3575c.2576.0377.3863.0565.4459.1194a.2498.2498 0 0 1 .0664.2047c-.0113.0859-.1046.1767-.291.3583l-1.769 1.723c-.0552.0537-.0827.0806-.1005.1125a.2501.2501 0 0 0-.0298.0915c-.0044.0364.0021.0743.0151.1502L8.951 9.711c.044.2566.066.385.0247.4611a.2498.2498 0 0 1-.1741.1265c-.0852.0158-.2005-.0448-.431-.166L6.1842 8.9829c-.068-.0358-.1021-.0537-.138-.0608a.25.25 0 0 0-.0963 0c-.0358.007-.0699.025-.138.0608l-2.1864 1.1498c-.2305.1212-.3458.1818-.431.166a.2498.2498 0 0 1-.174-.1265c-.0415-.0761-.0194-.2045.0246-.4611l.4174-2.4337c.013-.0759.0195-.1138.0151-.1502a.2501.2501 0 0 0-.0297-.0915c-.0178-.032-.0454-.0588-.1006-.1125l-1.769-1.723c-.1864-.1816-.2796-.2724-.291-.3583a.25.25 0 0 1 .0664-.2047c.0596-.0629.1883-.0817.4459-.1193l2.4456-.3575c.076-.0111.114-.0167.1472-.032a.25.25 0 0 0 .0777-.0566c.0249-.0268.042-.0612.076-.1302l1.0933-2.215Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
